<template>
  <get-started
    :label="companyName"
    :logoUrl="logoURL"
    :selectedLanguage="selectedLanguage"
    :languages="languages"
    :businessLoginAvailable="false"
    @startClassic="start"
    @changeLanguage="changeLanguage"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import { Authentication } from '@icabbi/vue-authentication';
import environment from '@/environment';
import { RoutePath } from '@/routing/routePath';
import { bookingChannelComputed } from '../mixins/bookingChannel.mixins';
import { languageMethods, languageComputed } from '../mixins/language.mixins';

export default {
  data() {
    return {
      loginUrl: false,
    };
  },
  mixins: [bookingChannelComputed, languageComputed, languageMethods],
  computed: {
    ...mapGetters({
      loginContext: 'authentication/loginContext',
      idToken: 'authentication/idToken',
      accessToken: 'authentication/token',
    }),
  },
  async created() {
    await this.setLoginUrl(await this.getLoginUrl());
  },
  methods: {
    start() {
      if (this.toMockAuth()) {
        this.$router.push({
          path: RoutePath.OAUTH_CALLBACK_PATH,
          query: {
            state: this.loginContext.state,
          },
        });
      } else {
        window.location = this.loginUrl;
      }
    },
    async setLoginUrl(url) {
      this.loginUrl = url;
    },
    async getLoginUrl() {
      return Authentication(this.$store).getLoginRedirectionUrl({
        to: { path: '/users' },
        clientId: this.oidcClientId,
        redirectUri: this.authCallbackUrl,
        locale: this.selectedLanguage,
        audience: process.env.VUE_APP_LOGIN_AUDIENCE,
        acrValues: process.env.VUE_APP_LOGIN_ACR_VALUES,
      });
    },
    async changeLanguage(language) {
      await this.selectLanguage(language);
      const loginUrl = await this.getLoginUrl();
      await this.setLoginUrl(loginUrl);
    },
    toMockAuth() {
      return environment.isInMockApiMode();
    },
  },
};
</script>
